import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled, { css } from "styled-components";

export enum ButtonVariant {
    Default,
    Placeholder,
    Active,
}

export const colorByVariant = {
    [ButtonVariant.Default]: colorsPalettes.carbon["500"],
    [ButtonVariant.Placeholder]: colorsPalettes.carbon["200"],
    [ButtonVariant.Active]: colorsPalettes.blue["500"],
};

export const setFilterButtonElementsColor = (variant: ButtonVariant) => css`
    border-bottom: 1px solid ${colorByVariant[variant]};

    ${SWReactIcons} path {
        fill: ${colorByVariant[variant]};
    }
`;

const setFilterButtonTextColor = (variant: ButtonVariant) => css`
    & * {
        color: ${colorByVariant[variant]};
    }
`;

export const setFilterButtonColor = (variant: ButtonVariant) => css`
    ${setFilterButtonTextColor(variant)}
    ${setFilterButtonElementsColor(variant)}
`;

export const primaryElementFont = (color?: string) => setFontVariant("h4", color);

export const StyledSignalFilterBlock = styled.div`
    display: inline-block;
    position: relative;
    width: max-content;
    min-width: 0;
`;
